module.exports =
  update: '/updater/update/:module'
  start: '/updater/start/:module'
  register: '/updater/register'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/updater.coffee